module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("No Role No Data")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a484b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Nodata.vue
// module id = 669
// module chunks = 1